import React, { useState, useEffect } from 'react';
import _, { lastIndexOf } from 'lodash';
import 'draft-js/dist/Draft.css';

import {
  Box,
  Typography,
  FormControlLabel,
  CircularProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from '@mui/material';

import useGlobalStatus from '../../../hook/useGlobalStatus';

import { BoxBorderGrey } from '../../customComponent';
import { CheckboxGreenMain } from '../../customComponent/checkbox';
import { handleColorSystem } from '../../customComponent/colorSystem';

import { ErrorOutlineIcon } from '../../../constants/images';
import theme from '../../../theme';


const fieldsBlockHeight = '500px';

const checkCampaignGoalsSelected = (currentData, originalData) => {
  return currentData.includes(originalData) ? true : false;
}

const LineFieldsTarget = (props) => {
  const {
    selectedAdAccounts,
    setCurrentSheetName,
    setCurrentSheetOrigiName,
    selectedExcelIndex,
    setSelectedExcelIndex,
    setCurrentSheetSelectFields,
    selectedGeneralFields,
    selectedCustomFields,
    campaignGoalsSelected,
    changeCampaignGoals,
    campaignGoalsList,
    loadingBox,
    setSearchKeyword
  } = props;

  const { currentActiveData, setCurrentActiveData } = useGlobalStatus();
  const { colorSystem, mainColor, lightColor, darkColor, w01Color } = handleColorSystem('LINE');

  //廣告目標點選按鈕變色
  const handleExcelClick = (e, index) => {
    setSelectedExcelIndex(index);
    setSearchKeyword("");
  };

  //目前廣告目標的預選欄位
  const handleDefaultFields = (sheetName) => {

    const sheetNotNull = selectedGeneralFields.filter((el) =>
      el.sheet !== null
    );

    const currentGeneralFields = sheetNotNull.filter((el) =>
      el.sheet.includes(sheetName)
    );

    let currentCustomFields = [];

    if (selectedCustomFields?.length > 0) {
      const sheetNotNull = selectedCustomFields.filter((el) =>
        el.sheet !== null
      );
      currentCustomFields = sheetNotNull.filter((el) =>
        el.sheet.includes(sheetName)
      )
    } else {
      currentCustomFields = [];
    }

    const totalCurrentFields = _.concat(currentGeneralFields, currentCustomFields);
    const sortSheetFields = totalCurrentFields.sort((a, b) => {
      if (a.indexNumber === null) return 1;
      if (b.indexNumber === null) return -1;
      return a.indexNumber - b.indexNumber;
    });

    setCurrentSheetSelectFields(sortSheetFields);
  }

  return (
    <Box
      sx={{
        flex: 1.2,
        borderRight: `1px solid ${theme.palette.grey.w200}`,
      }}
    >
      <Box
        sx={{
          padding: '16px 0px 12px 30px',
          background: `${theme.palette.grey.w100}`,
          borderBottom: `1px solid ${theme.palette.grey.w200}`
        }}
      >
        <Typography
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          廣告目標
        </Typography>
      </Box>

      <Box
        sx={{
          height: fieldsBlockHeight,
          overflow: 'auto',
          background: '#F8F8F8'
        }}
      >
        {
          !loadingBox && !selectedAdAccounts.length &&
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: theme.palette.grey.w300,
              p: '18px',
            }}
          >
            <ErrorOutlineIcon sx={{ top: '5px', right: '4px' }} />
            <Box sx={{ mt: '10px' }}>請先選擇廣告帳號</Box>
          </Box>
        }
        {
          !loadingBox && selectedAdAccounts.length !== 0 && !campaignGoalsList.length &&
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: theme.palette.grey.w300,
              p: '18px',
            }}
          >
            <ErrorOutlineIcon sx={{ top: '5px', right: '4px' }} />
            <Box sx={{ mt: '10px' }}>無法匯入廣告目標</Box>
          </Box>
        }
        {
          loadingBox === true &&
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: theme.palette.grey.w300,
            }}
          >
            <CircularProgress />
          </Box>
        }
        {
          campaignGoalsList.length !== 0 && !loadingBox && selectedAdAccounts.length !== 0 &&
          campaignGoalsList.map((el, index) => {
            return (
              <BoxBorderGrey
                key={el.campaignGoalName}
                sx={{
                  display: 'inline-block',
                  width: '100%',
                  border: '0px',
                  p: 0
                }}>
                <List component="div" disablePadding>
                  <ListItem
                    sx={{
                      width: 'auto',
                      padding: 0,
                    }}
                  >
                    <ListItemButton
                      value={el.campaignGoalName}
                      selected={selectedExcelIndex === index}
                      onClick={(e) => {
                        setCurrentSheetName(el.campaignGoalName);
                        setCurrentSheetOrigiName(el.campaignGoalEng);
                        handleExcelClick(e, index);
                        handleDefaultFields(el.campaignGoalEng);
                      }}
                      sx={{
                        padding: '5px 5px 5px 30px',
                        "&.Mui-selected": {
                          backgroundColor: theme.palette.line.line01
                        }
                      }}
                    >
                      <FormControlLabel
                        key={el.campaignGoalEng}
                        control={
                          <CheckboxGreenMain
                            size="small"
                            name={el.campaignGoalEng}
                            checked={checkCampaignGoalsSelected(campaignGoalsSelected, el.campaignGoalEng)}
                            onChange={changeCampaignGoals}
                          />
                        }
                        sx={{ marginRight: 0 }}
                      />
                      <ListItemText
                        id={el.campaignGoalEng}
                        primary={el.campaignGoalName}
                      >
                      </ListItemText>

                    </ListItemButton>
                  </ListItem>
                </List>

              </BoxBorderGrey>
            )
          })
        }
      </Box>
    </Box>
  )
}

export default LineFieldsTarget;